// @flow
import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import Button, { ButtonType } from '@rover/react-lib/components/buttons/Button';
import FormGroup from '@rover/react-lib/components/formFields/FormGroup';
import type { Pet } from '@rover/react-lib/types';
import { SexInfoConstants } from '@rover/shared/js/constants/translation';

import EmergencyFormSexField from './EmergencyFormSexField';

type Props = {
  pet: Pet,
  showNames: boolean,
  handleSexInfoChange: (gender: string) => void,
  value: string,
  isEditing: boolean,
  toggleEditing: (pet: Pet) => void,
};

const UpdateButton: StyledComponent<{}> = styled(Button)`
  padding: 0;
`;

const PetSexInfo = ({
  pet,
  showNames,
  handleSexInfoChange,
  value,
  isEditing,
  toggleEditing,
}: Props): Node => {
  const inputId = `sex-info-${pet.id}`;

  return (
    <FormGroup>
      {showNames && <label htmlFor={inputId}>{pet.name}</label>}
      <EmergencyFormSexField value={value} onChange={handleSexInfoChange} />
      {!isEditing && (
        <UpdateButton buttonType={ButtonType.TEXT} onClick={() => toggleEditing(pet)}>
          {SexInfoConstants.updateButton}
        </UpdateButton>
      )}
    </FormGroup>
  );
};

export default PetSexInfo;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/SexInfo/PetSexInfo.jsx